/**************************************************
 * Nombre:       Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import logo from '../Recursos/logo_completo.svg'
import {CONTACTOS, SECCIONES} from "../Constantes";
import {theme} from "../Tema";
import {irUrl} from "../Utilidades/irUrl";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../App";
import Dialogo_Politicas from "./Dialogos/Dialogo_Politicas";
import {useDialogo} from "../Modulo_Dialogos_2025/Hooks/useDialogo";
import {useResponsive} from "../Modulo_responsive/Hooks/useResponsive";


const Footer = () => {
    const cData = useContext(contexApp)
    const {sCell} = useResponsive()
    const [politicas, setPoliticas] = useState([]);
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Politicas})

    useEffect(() => {
        setPoliticas(cData.politicas);
    }, [cData])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderTop: 1, borderColor: '#000'}}
        >
            <Dialogo/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 8}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >


                        <Grid container size={{xs: 12, sm: 12, md: 4}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                            <img src={logo} width={250} height={'auto'}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 2}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? 3 : 0}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontWeight: 800, fontSize: 18}}>Link Rapidos</Typography>
                                </Grid>

                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}>

                                    {SECCIONES.map((it, index) => (
                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: 1}}>
                                            <Typography>{it}</Typography>
                                        </Grid>
                                    ))}

                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 3}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? 3 : 0}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontWeight: 800, fontSize: 18}}>Contactos</Typography>
                                </Grid>

                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}>

                                    {CONTACTOS.map((it, index) => (
                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: 1}}>
                                            <Typography
                                                onClick={() => irUrl(it.url)}
                                                sx={{
                                                    color: '#000',
                                                    cursor: 'pointer',
                                                    '&:hover': {
                                                        color: theme.palette.primary.main,
                                                    }
                                                }}

                                            >{it.descripcion}</Typography>
                                        </Grid>
                                    ))}

                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 3}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? 3 : 0}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontWeight: 800, fontSize: 18}}>Politicas</Typography>
                                </Grid>

                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}>

                                    {politicas.map((it, index) => (
                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: 1}}>
                                            <Typography
                                                onClick={() => abrir(it)}
                                                sx={{
                                                    color: '#000',
                                                    cursor: 'pointer',
                                                    '&:hover': {
                                                        color: theme.palette.primary.main,
                                                    }
                                                }}

                                            >{it.titulo}</Typography>
                                        </Grid>
                                    ))}

                                </Grid>

                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundColor: theme.palette.primary.main,
                    py: 2
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Typography sx={{color: '#fff'}}>© GENERACION MEZCAL 2026 - 2027</Typography>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Footer